import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!

  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(["list", `horizontal-gap--${$props.horizontalGap}`])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (item) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "item",
        key: item
      }, [
        _createVNode(_component_app_icon, {
          class: "icon",
          type: "check"
        }),
        _createElementVNode("span", null, _toDisplayString(item), 1)
      ]))
    }), 128))
  ], 2))
}